import { IApp04TopicUser } from "./App04TopicUser";
import { EntityWithStatus, IEntityWithStatus } from "./EntityWithStatus";

export interface IApp04Topic extends IEntityWithStatus {
    AppID?: number;
    WebSearch?: string;
    WebSearchSites?: string;
    CreatedByUserID?: number;
    CustomerID?: number;
    CreatedOn?: Date;
    UpdatedOn?: Date;

    //App04AIChats?: IApp04AIChat[];
    App04TopicUsers?: IApp04TopicUser[];
}

export class App04Topic extends EntityWithStatus implements IApp04Topic {
    public AppID = null;
    public WebSearch = null;
    public WebSearchSites = null;
    public CreatedByUserID = null;
    public CustomerID = null;
    public CreatedOn = null;
    public UpdatedOn = null;

    //public App04AIChats = null;
    public App04TopicUsers = null;
}